import React, { Component } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalFiltersLive.scss';
import { Grid, Row, Column, Button, cls, Heading } from '../../packages/components';
import { ColoredButton } from '../../packages/components/lib/ColoredButton/';
import Device from '../../devices/device';

class ModalFilterLive extends Component {
    constructor() {
        super();
        this.modalProps = {
            childrenClassName: 'modal_full_height',
        };
        this.keys = Device.getDevice().getKeys();
    }

    componentDidMount = () => {
        this.addListener();
        window && window.SpatialNavigation && (typeof window.SpatialNavigation.focus === 'function') && typeof window.SpatialNavigation.focus('.modal_categorie_button_filter');
    }

    componentWillUnmount = () => {
        this.removeListener();
    }


    handleKey = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case 'YELLOW':
                e.preventDefault();
                e.stopPropagation();
                if(this.props && (typeof this.props.yellowRCU === 'function')){
                    this.props.handleClose(null, this.props.yellowRCU);
                }
            break;
            case 'GREEN':
                e.preventDefault();
                e.stopPropagation();
                    this.props.handleClose(null, null);
            break;
        }
    }

    addListener = () => {
        document.addEventListener('keydown', this.handleKey, true);
    }

    removeListener = () => {
        document.removeEventListener('keydown', this.handleKey, true);
    }

    renderButtonsBody = (buttons) => {
        if (Array.isArray(buttons)) {
            return buttons.map((btn, index) => {
                if(!btn) return null;
                return (
                    <Column size={12}>
                        <Button
                            id={`modalfilterlive_button_${index}`}
                            type="button"
                            variant={btn.variant ? btn.variant : 'dark'}
                            onClick={() =>
                                typeof btn.onClick === 'function' &&
                                this.props.handleClose(null, btn.onClick)
                            }
                            className={cls(`focusable modal_categorie_button_filter`)}>
                            {btn.title || ''}
                        </Button>
                    </Column>
                );
            });
        } else {
            return null;
        }
    };

    renderButtonsFooter = (buttons) => {


        if (Array.isArray(buttons)) {
            return buttons.map((btn) => {
                return (
                    <ColoredButton
                        color={btn.color || 'yellow'}
                        className={cls(`modal_filter_live_button_colour`,`modal_filter_live_button_colour_${btn.color || ''}`, `focusable`)}
                        onClick={() =>
                            typeof btn.onClick === 'function' &&
                            this.props.handleClose(null, btn.onClick)
                        }
                        imgSrc = {btn && btn.image || null}>
                        {btn.title || ''}
                    </ColoredButton>
                );
            });
        } else {
            return null;
        }
    };
    render() {
        return (
            <ModalWrapper {...this.modalProps}>
                <Grid>
                    <Row className={cls(`modal_filter_live_footer`)}>
                        <Column size={12}>
                            {this.props &&
                                this.props.buttonsFooter &&
                                this.renderButtonsFooter(this.props.buttonsFooter)}
                        </Column>
                    </Row>
                    <Row className={cls(`modal_filter_live_body`)}>
                        <Column size={12}>
                            <Heading size={3} className={cls(`modal_filter_live_title`)}>
                                {this.props.title}
                            </Heading>
                        </Column>
                        {this.props &&
                            this.props.buttonsBody &&
                            this.renderButtonsBody(this.props.buttonsBody)}
                    </Row>
                </Grid>
            </ModalWrapper>
        );
    }
}

export default withOnClose(ModalFilterLive);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalFilterLive.jsx